import { render, staticRenderFns } from "./FareList.vue?vue&type=template&id=e7d0cb64&scoped=true&"
import script from "./FareList.vue?vue&type=script&lang=js&"
export * from "./FareList.vue?vue&type=script&lang=js&"
import style0 from "./FareList.vue?vue&type=style&index=0&id=e7d0cb64&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7d0cb64",
  null
  
)

export default component.exports